import React from "react";
import { Typography } from "../../../../ui/components/typography/Typography";
export const NotificationContent = ({ title, lines, }) => {
    return (React.createElement(Typography, { appearance: "moderate", as: "div", typographyType: "body-sm" },
        !!title && React.createElement("p", { className: "font-semibold" }, title),
        React.createElement("div", null, lines.map((line) => (React.createElement("span", { key: line }, line))))));
};
